module.exports = __webpack_public_path__ + "static/img/produto_g.dfd821f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-retro/produto_g.png
// module id = l/Og
// module chunks = 0